import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Accordion, AccordionTab } from 'primereact/accordion';
import CreateQuestionBank from '../../../components/Survey/CreateQuestion';
import { useQuestionBank } from '../../../Hooks/Features/SurveyManagement/useQuestionBank';
import CommanDialog from '../../../components/CommonCompo/CommanDialog/CommanDialog';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';
import PanelHeaderTemplate from '../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';
import { dateConvert } from '../../../utils/Helper';
import { useCommon } from '../../../Hooks/Common/useCommon';
import _ from 'underscore';
import { SkeletonDataTable } from '../../../components/Loader/Loader';

function QuestionBank({ fromComp, questions, setQuestions, disabled, surveyQuestions }) {
    const {
        showPopUp, setShowPopup, options, setOptions, activeIndex, setActiveIndex, categorySelectAll, fetchQuestionsByCategory, filterValue, setFilterValue, selectedQuestions, getSortedQuestions, handleSort, tagRef, loading,
        handleQuestionSelect, confirmationPopup, setConfirmationPopup, handleDelete, handleDuplicate, questionList, handleOrderNumberChange, isExpanded, setIsExpanded } = useQuestionBank({ questions, setQuestions, surveyQuestions, fromComp });
    const { checkPermission } = useCommon();
    const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);

    return (
        <div ref={() => checkPermission("survey", tagRef)}>
            <div ref={tagRef} id='{"tabname": "survey", "data": "question_bank_tab"}' style={{ height: `${(fromComp === "create" || fromComp === "evaluator" || fromComp === "direct") ? "" : "90vh"}` }}>
                {(fromComp !== "evaluator" && fromComp !== "direct" && !disabled) ? (
                    <div className='d-flex justify-content-between m-2 align-items-center'>
                        <div></div>
                        <div className='d-flex gap-2 align-items-center'>
                            {
                                isExpanded ? <button title="Collapse All" className="sk-btn-primary rounded" onClick={() => setIsExpanded(false)}><FontAwesomeIcon icon="fa-solid fa-list" /></button> : <button title="Expand All" className="sk-btn-primary rounded" onClick={() => setIsExpanded(true)}><FontAwesomeIcon icon="fa-solid fa-expand" /></button>
                            }
                            <button
                                className="sk-btn sk-btn-primary "
                                onClick={() => fetchQuestionsByCategory()}
                                title="Refresh"
                            >
                                <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                            </button>
                            {fromComp !== "create" && (
                                <button
                                    className={`sk-btn ${showFiltersDrawer ? 'sk-btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => setShowFiltersDrawer(true)}
                                    title="Filters"
                                >
                                    <FontAwesomeIcon icon="fa-solid fa-filter" />
                                </button>
                            )}
                            <button className="sk-btn bg-black text-white sk-btn-primary" onClick={() => setShowPopup({ show: true, data: {} })}>
                                <FontAwesomeIcon icon="fa-solid fa-add" /> New Question
                            </button>
                        </div>
                    </div>
                ) : null}
                <div className='d-flex justify-content-end'>
                    {
                        (fromComp === "evaluator" || fromComp === "direct" || disabled) && <div>
                            {isExpanded ? <span title="Collapse All" className="text-decoration-underline text-primary fw-semibold px-2 c-pointer" onClick={() => setIsExpanded(false)}>Expand</span> : <span title="Expand All" className="text-decoration-underline text-primary fw-semibold px-2 c-pointer" onClick={() => setIsExpanded(true)}>Collapse</span>}
                        </div>
                    }
                </div>
                <div className={fromComp === "evaluator" ? "" : 'my-2'} style={{ height: (fromComp !== "create" && fromComp !== "evaluator" && fromComp !== "direct") ? "calc(95vh - 70px)" : "auto", overflowY: "auto" }}>
                    {
                        loading ? <SkeletonDataTable numSkeletons={20} /> : <Accordion
                            multiple
                            activeIndex={activeIndex}
                            onTabChange={(e) => { setActiveIndex(e.index) }}
                            className="w-full"
                        >
                            {questionList?.map((item, index) => (
                                <AccordionTab
                                    key={item?.category || index}
                                    headerTemplate={() => (
                                        <div className={`d-flex align-items-center justify-content-between w-100 ${(fromComp === "create" || fromComp === "evaluator" || fromComp === "direct") ? "" : "p-2"}`}>
                                            <div className="d-flex align-items-center gap-2">
                                                {(fromComp === "create" || fromComp === "evaluator" || fromComp === "direct") ? (
                                                    <input
                                                        type="checkbox"
                                                        disabled={disabled || false}
                                                        checked={categorySelectAll[item?.category] || false}
                                                        onChange={(e) => handleQuestionSelect(item?.category, true, e.target.checked)}
                                                        onClick={(e) => e.stopPropagation()}
                                                    />
                                                ) : <></>}
                                                <div className='d-flex'>
                                                    <div className="font-semibold">{item.name}</div>
                                                    {item?.category_display_name && (
                                                        <div
                                                            style={{
                                                                backgroundColor: '#e5e5e5',
                                                                borderRadius: '8px',
                                                                padding: "0px 8px",
                                                                color: 'black',
                                                                margin: "0px 10px"
                                                            }}
                                                        >
                                                            {item.category_display_name}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className='d-flex gap-2 align-items-center justify-content-end'>
                                                {(fromComp === "create" && questions?.category?.[item?.id]) && <input placeholder='Order' className='bg-white w30 border ms-2' type='text' value={selectedQuestions?.value?.category?.[item?.id]?.category_order_number} onChange={(e) => handleOrderNumberChange(e, item, true)} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} />}
                                                <small className={`rounded px-2 ${(fromComp === "create" || fromComp === "evaluator" || fromComp === "direct") ? "" : "py-1"}`} style={{ background: '#d4d4d4' }}>
                                                    {(fromComp === "create" || fromComp === "evaluator" || fromComp === "direct") && (selectedQuestions?.category_wise?.[item.category] || "0") + " / "} {item?.questions?.length || 0} Questions
                                                </small>
                                            </div>
                                        </div>
                                    )}
                                >

                                    <div className="table-responsive">
                                        <table className="table-sm">
                                            <thead className="">
                                                <tr>
                                                    {(fromComp === "create" || fromComp === "evaluator" || fromComp === "direct") && <th style={{ width: '20px', color: "#858585", background: '#e5e5e5' }}></th>}
                                                    <th style={{ color: "#858585", background: '#e5e5e5', fontWeight: "600" }}>Question Text</th>
                                                    {fromComp !== "evaluator" && <th
                                                        className='text-center c-pointer'
                                                        style={{ width: '50px', color: "#858585", background: '#e5e5e5', fontWeight: "600" }}
                                                        onClick={() => handleSort(index, 'question_type_name')}
                                                    >
                                                        Type↑↓
                                                    </th>}
                                                    <th
                                                        className='text-center c-pointer '
                                                        style={{ width: '40px', color: "#858585", background: '#e5e5e5', fontWeight: "600" }}
                                                        onClick={() => handleSort(index, 'order_number')}
                                                    >
                                                        Order↑↓
                                                    </th>
                                                    {(fromComp !== "evaluator" && fromComp !== "direct") && <th
                                                        className='text-center c-pointer '
                                                        style={{ width: '40px', color: "#858585", background: '#e5e5e5', fontWeight: "600" }}
                                                        onClick={() => handleSort(index, 'used')}
                                                    >
                                                        Used↑↓
                                                    </th>}
                                                    {fromComp !== "create" && fromComp !== "evaluator" && fromComp !== "direct" && <th className='text-center' style={{ width: '140px', color: "#858585", background: '#e5e5e5', fontWeight: "600" }}>Action</th>}
                                                </tr>
                                            </thead>
                                            <tbody className={((fromComp === "create" || fromComp === "evaluator" || fromComp === "direct")) ? "survey_questions" : ""}>
                                                {
                                                    getSortedQuestions(index).map((question) => (
                                                        <tr key={question.question_id}>
                                                            {(fromComp === "create" || fromComp === "evaluator" || fromComp === "direct") && (
                                                                <td className="p-1" style={{ width: '20px' }}>
                                                                    <input
                                                                        disabled={disabled || false}
                                                                        type="checkbox"
                                                                        className="input-dd mt-1"
                                                                        checked={_.pluck(Object.values(selectedQuestions?.value?.questions), "question_id")?.includes(question?.question_id) || false}
                                                                        onChange={() => handleQuestionSelect(question)}
                                                                    />
                                                                </td>
                                                            )}
                                                            <td className="p-2 align-middle">
                                                                <span className="font-semibold" title={question.question_title}>
                                                                    {question.question_title}
                                                                </span>
                                                            </td>
                                                            {fromComp !== "evaluator" && <td className="text-center p-2 align-middle" style={{ width: '50px' }}>
                                                                <span className="border rounded px-2 fw-semibold d-inline-block" >
                                                                    {question.question_type_name || 'N/A'}
                                                                </span>
                                                            </td>}

                                                            <td className="text-center p-2 align-middle fw-semibold c-pointer"
                                                                style={{ width: '40px' }}
                                                            >
                                                                {(fromComp === "create" && !_.isEmpty(selectedQuestions?.value?.questions?.[question?.question_id])) ? <input className='bg-white border w90 ms-2' type='text' value={selectedQuestions?.value?.questions?.[question?.question_id]?.question_order_number} onChange={(e) => handleOrderNumberChange(e, question, false)} /> : (fromComp === "evaluator" || fromComp === "direct") ? question?.question_order_number : question?.order_number || 0}
                                                            </td>

                                                            {(fromComp !== "evaluator" && fromComp !== "direct") && <td className="text-center p-2 align-middle fw-semibold c-pointer"
                                                                style={{ width: '40px' }}
                                                                onClick={() => setConfirmationPopup({ type: "used", show: true, data: question })}
                                                            >
                                                                {question.used || 0}
                                                            </td>}
                                                            {(fromComp !== "create" && fromComp !== "evaluator" && fromComp !== "direct") && (
                                                                <td className="p-1 align-middle" style={{ width: '100px' }}>
                                                                    <div className="d-flex gap-2 justify-content-center">
                                                                        <button className="btn btn-sm p-1 border-0 bg-transparent" title="Duplicate" onClick={() => setConfirmationPopup({ type: "duplicate", show: true, data: question, newValue: `Copy of ${question?.question_title}` })}>
                                                                            <FontAwesomeIcon icon="fa-solid fa-copy" style={{ color: "#686767" }} />
                                                                        </button>

                                                                        <button className="btn btn-sm p-1 border-0 bg-transparent" title="Edit" onClick={() => {
                                                                            setShowPopup({ show: true, data: question })
                                                                        }}>
                                                                            <FontAwesomeIcon icon="fa-solid fa-pen-to-square" style={{ color: "#686767" }} />
                                                                        </button>
                                                                        <button className="btn btn-sm p-1 border-0 bg-transparent text-danger" title="Delete"
                                                                            onClick={() => setConfirmationPopup({ type: "delete", show: true, data: question })}>
                                                                            <FontAwesomeIcon icon="fa-solid fa-trash" />
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            )}
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </AccordionTab>
                            ))}
                        </Accordion>
                    }

                </div>
                {showPopUp?.show && (
                    <CreateQuestionBank
                        showPopUp={showPopUp}
                        handleClose={() => setShowPopup({ show: false, data: {} })}
                        options={options}
                        setOptions={setOptions}
                        apiCall={(question_title) => { fetchQuestionsByCategory(question_title); setShowPopup({ show: false, data: {} }) }}
                        questionList={questionList}
                        fromSurvey={fromComp === "create"}
                    />
                )}
                {
                    confirmationPopup?.type === "delete" && <CommanDialog
                        visible={confirmationPopup?.show}
                        message="Are you sure you want to delete this question?"
                        handleClose={() => { setConfirmationPopup({ type: "", show: false, data: "" }) }}
                        handleFun={handleDelete}
                    />
                }
                {
                    confirmationPopup?.type === "duplicate" && <Dialog visible={confirmationPopup?.show} modal onHide={() => { setConfirmationPopup({ type: "", show: false, id: "" }) }} className='modal-small' draggable={false} header={() => <div>Duplicate Question</div>}>
                        <div className='row'>
                            <div className='my-1'  >
                                <p className='w100 text-secondary fw-semibold' >Create a copy of this question. The new question will be placed in the same category. Please provide a new, unique question text.</p>
                                <div className='col-12 my-2'>
                                    <label className='detail-label'>Original Question</label><br />
                                    <textarea
                                        value={confirmationPopup?.data?.question_title}
                                        rows="3"
                                        className="form-control"
                                        name=''
                                        placeholder="Respondent's answer..."
                                        disabled
                                    />
                                </div>
                                <div className='col-12 my-2'>
                                    <label className='detail-label'>New Question Text</label><br />
                                    <textarea value={confirmationPopup?.newValue} type='text' className="form-control" onChange={(e) => {
                                        setConfirmationPopup((prev) => ({ ...prev, newValue: e.target.value }))
                                    }} rows="3" />
                                </div>
                            </div>
                            <div className='w-100 d-flex justify-content-end gap-2'>
                                <button className='btn-default' label="Close" onClick={() => { setConfirmationPopup({ type: "", show: false, data: "" }) }} >Cancel</button>
                                <button className='btn-primary' label="Close" onClick={handleDuplicate} >Create Duplicate</button>
                            </div>
                        </div>
                    </Dialog>
                }
                {
                    confirmationPopup?.type === "used" && <Dialog visible={confirmationPopup?.show} modal onHide={() => { setConfirmationPopup({ type: "", show: false, id: "" }) }} className='modal-small' draggable={false} header={() => <div> Survey Usage</div>}>
                        <div className='w100 p-2 text-secondary fw-semibold'>{confirmationPopup?.data?.question_title}</div>
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th style={{ width: '70%' }}>Survey Name</th>
                                        <th className='text-center' style={{ width: '30%' }}>Publish Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {confirmationPopup?.data?.survey_usage?.map((value, index) => (
                                        <tr key={index}>
                                            <td>{value?.survey_name}</td>
                                            <td className='text-center'>{dateConvert(value?.publish_datetime, "day-month-year") || "-"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </Dialog>
                }
            </div>

            {/* Right Panel Filters Drawer */}
            <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
                <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                    <div className="sk-drawer-header">
                        <h5 className="sk-drawer-title">Filters</h5>
                        <div className="d-flex align-items-center gap-2">
                            <button className="sk-drawer-clear-btn" onClick={() => {
                                setFilterValue((prev) => {
                                    const updated = { ...prev, category: [], isChange: true };
                                    setTimeout(() => {
                                        fetchQuestionsByCategory();
                                    }, 0);
                                    return updated;
                                });
                            }}>Clear All</button>
                            <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                                <FontAwesomeIcon icon="fa-solid fa-xmark" />
                            </button>
                        </div>
                    </div>
                    <div className="sk-drawer-body">
                        <div className='d-flex flex-column gap-4'>
                            {/* Category Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Category</div>
                                <MultiSelect
                                    name="category"
                                    options={options?.category}
                                    value={filterValue?.category}
                                    onChange={(e) => { setFilterValue((prev) => ({ ...prev, category: e.value, isChange: true })) }}
                                    placeholder="Select a Category"
                                    className="input-dd w-100"
                                    optionLabel="question_category_name"
                                    filter
                                    onHide={() => {
                                        if (filterValue?.isChange) {
                                            fetchQuestionsByCategory();
                                            setFilterValue((prev) => ({ ...prev, isChange: false }));
                                        }
                                    }}
                                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'environment', filterValue?.category, (val) => setFilterValue((prev) => ({ ...prev, category: val })), () => { setFilterValue((prev) => ({ ...prev, isChange: true, category: [] })); })}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="sk-drawer-footer">
                        <button className="sk-btn sk-btn-primary w-100" onClick={() => {
                            if (filterValue?.isChange) {
                                fetchQuestionsByCategory();
                                setFilterValue((prev) => ({ ...prev, isChange: false }));
                            }
                            setShowFiltersDrawer(false);
                        }}>Apply Filters</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QuestionBank;

